import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Modal,
  TextField,
} from "@material-ui/core";
import { Asterisk, CloudArrowUp } from "phosphor-react";
import React, { useEffect, useRef } from "react";
import useStyles from "./ProjectPageNewProjectModal.styles";

import PropTypes from "prop-types";
import { fget, fpatch, fpost } from "./../../../API/callsAPI";
//Validators
import MomentUtils from "@date-io/moment";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { MenuItem, Select } from "@mui/material";
import { useFormik } from "formik";
import moment from "moment";
import { useState } from "react";
import { X } from "react-feather";
import * as yup from "yup";
import MovieColabWarnings from "../../Utilities/ErrorOrSuccessMessage/MovieColabWarnings";
import HelperText from "../../Utilities/HelperText/HelperText";
import SelectUserModal from "../../Utilities/ManageUsers/SelectUsersModal/SelectUserModal.component";
import ModalTitleAndButtons from "../../Utilities/ModalTitleAndButtons/ModalTitleAndButtons.component";
//
export default function ProjectPageNewProjectModal({
  type,
  project,
  handleClose,
  updateRefreshToken,
  setSnackValue,
  usersList,
  openDeleteProjectModal,
  selectedTeam,
  teamList,
}) {
  const classes = useStyles();
  const uploadThumbnailRef = useRef(null);
  const [thumbnail, uploadThumbnailSet] = React.useState();
  const [thumbnailTouched, setThumbnailTouch] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [projectUsers, setProjectUsers] = useState([]);
  const [projectAdmin, setProjectAdmin] = useState([]);
  const [isSelectAdminModalOpen, setSelectAdminModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
  };

  const handleThumbnailUpload = (e) => {
    let file = e.target.files[0];
    uploadThumbnailSet(file);
    setThumbnailTouch(true);
  };

  const removeThumbnail = () => {
    uploadThumbnailSet(null);
    setThumbnailTouch(false);
    setIsHovered(false);
  };

  const handleSelectAdmin = (admins) => {
    setProjectAdmin(admins);
  };

  const handleSelectUser = (users) => {
    setProjectUsers(users);
  };

  const handleSelectAdminModalState = () => {
    setSelectAdminModalOpen(!isSelectAdminModalOpen);
  };

  const handleSelectUserModalState = () => {
    setSelectUserModalOpen(!isSelectUserModalOpen);
  };

  useEffect(() => {
    const admins = usersList?.filter((el) =>
      project?.admin_users?.includes(el.value),
    );
    const users = usersList?.filter((el) => project?.users?.includes(el.value));
    setProjectAdmin(admins);
    setProjectUsers(users);
    if (project?.thumbnail?.length > 0) {
      console.log("true");
      setThumbnailTouch(true);
    }
  }, [project]);

  //Validators
  const NewProjectValidationSchema = yup.object({
    projectName: yup
      .string("String required")
      .label("projectName")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required("This is a required field"),

    abbreviation: yup
      .string("String required")
      .label("abbreviation")
      .max(15, "Maximum Character Limit: 15")
      .required("This is a required field"),

    description: yup
      .string("String required")
      .label("description")
      .max(100, "Maximum Character Limit: 100")
      .required("This is a required field"),
  });
  const formik = useFormik({
    initialValues: {
      projectName: project?.name ? project?.name : "",
      abbreviation: project?.abbreviation ? project?.abbreviation : "",
      description: project?.description ? project?.description : "",
      project_space: "",
    },
    validationSchema: NewProjectValidationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();

      setLoader(true);
      formData.append("name", values.projectName);
      formData.append("abbreviation", values.abbreviation);
      formData.append("description", values.description);
      formData.append("project_space", values.project_space);
      formData.append(
        "completion_date",
        new Date(selectedStartDate).toISOString(),
      );
      thumbnail && formData.append("thumbnail", thumbnail);
      if (projectAdmin.length > 0) {
        for (let i = 0; i < projectAdmin.length; i++) {
          formData.append("admin_users", projectAdmin[i]?.value);
        }
      }
      if (projectUsers.length > 0) {
        for (let i = 0; i < projectUsers.length; i++) {
          formData.append("users", projectUsers[i]?.value);
        }
      }

      try {
        if (type === "New") {
          const newProject = {
            url: "project/",
            data: formData,
          };
          const newProjectRes = await fpost(newProject);
          if (newProjectRes.status === 200 || 201) {
            setLoader(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully Created "${newProjectRes.data.name}"`,
              isError: false,
            });
          }
          updateRefreshToken();
          handleClose();
        } else {
          const editProject = {
            url: `project/${project.id}/`,
            data: formData,
          };
          const editProjectRes = await fpatch(editProject);
          if (editProjectRes.status === 200 || 201) {
            setLoader(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully edited "${editProjectRes.data.name}"`,
              isError: false,
            });
          }
          updateRefreshToken();
          handleClose();
        }
      } catch (error) {
        setLoader(false);
        setSnackValue({
          isOpen: true,
          message: `${error}`,
          isError: true,
        });
      }
    },
  });

  const [currentTierDetails, setCurrentTierDetails] = useState();
  useEffect(() => {
    const handleGetTierStatus = async () => {
      try {
        const res = await fget({
          url: `project-space/${formik.values.project_space}/tier-status/`,
        });
        setCurrentTierDetails(res?.data);
      } catch (error) {
        console.log(error);
      }
    };
    if (formik.values.project_space) {
      handleGetTierStatus();
    }
  }, [formik.values.project_space]);

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <form onSubmit={formik.handleSubmit}>
            <ModalTitleAndButtons
              name="Project"
              type={type}
              closeModal={() => handleClose()}
              openDeleteModal={openDeleteProjectModal}
            />

            <div className={classes.imageInputAndNameAndAbbreviation}>
              <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "30%" }}>
                <span className={classes.inputLabel}>Project Thumbnail</span>
                {thumbnailTouched ? (
                  <div
                    className={classes.imageViewerDiv}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <div
                      className={classes.removeThumbnailIcon}
                      onClick={() => removeThumbnail()}
                      style={{
                        display: isHovered ? "flex" : "none",
                      }}
                    >
                      <X size={18} />
                    </div>
                    <div className={classes.imageContentDiv}>
                      <img
                        className={classes.projectThumbnail}
                        src={
                          thumbnail
                            ? URL.createObjectURL(thumbnail)
                            : project?.thumbnail
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className={classes.cardContentDiv2}>
                    <input
                      ref={uploadThumbnailRef}
                      type="file"
                      className={classes.imageInput}
                      accept="image/png, image/jpeg"
                      id="thumbnailUpload"
                      onChange={(e) => handleThumbnailUpload(e)}
                    />
                  </div>
                )}
                <Button
                  disabled={thumbnailTouched}
                  variant="contained"
                  startIcon={<CloudArrowUp size={16} />}
                  color="primary" onClick={() => uploadThumbnailRef.current.click()} style={{ width: "100%", marginTop: "10px", backgroundColor: "transparent", boxShadow: "none" }}>
                  Upload
                </Button>
              </div>

              <div style={{ marginLeft: "3%", width: "70%" }}>
                <div>
                  <span className={classes.inputLabel}>Team</span>
                  <Select
                    value={formik.values.project_space}
                    name="project_space"
                    onChange={formik.handleChange}
                    className={classes.dropdownStyle}
                    sx={{
                      marginTop: "-8px",
                      marginBottom: "8px",
                    }}
                    //menu props
                    MenuProps={{
                      PaperProps: {
                        style: {
                          backgroundColor: "#252A38",
                          color: "#fff !important",
                          padding: "0px",
                        },
                        "& .MuiMenuItem-root": {
                          color: "#fff !important",
                          backgroundColor: "#252A38",
                        },
                      },
                    }}
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                  >
                    {teamList?.map((sin) => (
                      <MenuItem
                        key={sin.id}
                        value={sin.id}
                        sx={{
                          color: "#fff !important",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="20" height="20" rx="2" fill="#659BD9" />
                        </svg>
                        {sin?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                {Number(currentTierDetails?.total_projects_created) >=
                  Number(currentTierDetails?.tier_project_limit) && (
                    <MovieColabWarnings
                      warningText={`You've hit the project cap on your current plan. Upgrade your team plan
        to unlock more projects.`}
                    />
                  )}
                <div>
                  <span className={classes.inputLabel}>Project Name</span>
                  <Asterisk size={12} color="#FF0000" weight="fill" />
                  <div className={classes.cardContentDiv3}>
                    <TextField
                      type="text"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          fontFamily: "Poppins",
                        },
                      }}
                      className={classes.cardContentInput1}
                      placeholder="Enter project name"
                      name="projectName"
                      onChange={formik.handleChange}
                      value={formik.values.projectName}
                      error={
                        formik.touched.projectName &&
                        Boolean(formik.errors.projectName)
                      }
                    />
                    {formik.errors.projectName && formik.touched.projectName ? (
                      <HelperText text={formik.errors.projectName} />
                    ) : null}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "6%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <span className={classes.inputLabel}>
                      Project Abbreviation
                    </span>
                    <Asterisk size={12} color="#FF0000" weight="fill" />
                    <div className={classes.datePickerDiv}>
                      <TextField
                        type="text"
                        InputProps={{
                          disableUnderline: true,
                          style: {
                            fontFamily: "Poppins",
                          },
                        }}
                        className={classes.cardContentInput1}
                        placeholder="Enter Abbreviation"
                        name="abbreviation"
                        onChange={formik.handleChange}
                        value={formik.values.abbreviation}
                        error={
                          formik.touched.abbreviation &&
                          Boolean(formik.errors.abbreviation)
                        }
                      />
                      {formik.errors.abbreviation &&
                        formik.touched.abbreviation ? (
                        <HelperText text={formik.errors.abbreviation} />
                      ) : null}
                    </div>
                  </div>
                  <div style={{ width: "100%" }}>
                    <span className={classes.inputLabel}>Completion Date</span>
                    <div className={classes.datePickerDiv}>
                      <MuiPickersUtilsProvider
                        libInstance={moment}
                        utils={MomentUtils}
                      >
                        <KeyboardDatePicker
                          disableToolbar
                          autoOk
                          invalidDateMessage={"inValid"}
                          variant="inline"
                          format="yyyy/MM/DD"
                          margin="normal"
                          name="startDate"
                          value={selectedStartDate}
                          onChange={(date) =>
                            handleStartDateChange(new Date(date))
                          }
                          style={{ marginTop: "5px", height: "30px" }}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          id="Startdate-picker"
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                            style: {
                              padding: "0px",
                            },
                          }}
                          className={classes.cardContentInput1}
                          size="small"
                          fullWidth={true}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.cardContentDiv4}>
              <span className={classes.inputLabel}>Description</span>
              <Asterisk size={12} color="#FF0000" weight="fill" />
              <div>
                <TextField
                  type="text"
                  id="desc"
                  placeholder="Enter a project description"
                  className={classes.cardContentInput1}
                  style={{ height: "70px", overflow: "auto" }}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      fontFamily: "Poppins",
                    },
                  }}
                  name="description"
                  onChange={formik.handleChange}
                  value={formik.values.description}
                  error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                  }
                  multiline
                />
                {formik.errors.description && formik.touched.description ? (
                  <HelperText text={formik.errors.description} />
                ) : null}
              </div>
            </div>

            {/* {type === "New" && (
              <>
                <div className={classes.label}>
                  <label>Select Admin</label>
                  <Divider flexItem className={classes.divider} />
                </div>
                <UserViewerForManageUsers
                  currentUsers={projectAdmin}
                  handleSelectUserModalChange={handleSelectAdminModalState}
                  handleSelectUsers={handleSelectAdmin}
                />

                <div className={classes.label}>
                  <label>Select Users</label>
                  <Divider flexItem className={classes.divider} />
                </div>
                <UserViewerForManageUsers
                  currentUsers={projectUsers}
                  handleSelectUserModalChange={handleSelectUserModalState}
                  handleSelectUsers={handleSelectUser}
                />
              </>
            )} */}
            <CardActions className={classes.cardAction}>
              <Button
                className={classes.doneButton}
                type="submit"
                value="Submit"
                size="small"
                disableElevation
                disabled={
                  Number(currentTierDetails?.total_projects_created) >=
                  Number(currentTierDetails?.tier_project_limit)
                }
              >
                {loader ? (
                  <CircularProgress style={{ width: "25px", height: "25px" }} />
                ) : (
                  <>{type === "New" ? "Create New Project" : "Save"}</>
                )}
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
      <div>
        {/* to select admins */}
        <Modal
          className={classes.modal}
          open={isSelectAdminModalOpen}
          onClose={() => setSelectAdminModalOpen(!isSelectAdminModalOpen)}
        >
          <SelectUserModal
            closeModal={() => setSelectAdminModalOpen(!isSelectAdminModalOpen)}
            assignedUser={projectAdmin}
            usersList={usersList}
            handleSelectUsers={handleSelectAdmin}
          />
        </Modal>
        {/* to select users */}
        <Modal
          className={classes.modal}
          open={isSelectUserModalOpen}
          onClose={() => setSelectUserModalOpen(!isSelectUserModalOpen)}
        >
          <SelectUserModal
            closeModal={() => setSelectUserModalOpen(!isSelectUserModalOpen)}
            assignedUser={projectUsers}
            usersList={usersList}
            handleSelectUsers={handleSelectUser}
          />
        </Modal>
      </div>
    </div>
  );
}

ProjectPageNewProjectModal.propTypes = {
  handleClose: PropTypes.func,
};
